import { useQuery } from 'react-query';
import http from '../config/http-service';
import { masterProductsEndpoint } from './use-get-master-products-api';

// GET api/v1/cms/master-products/spec-values — distinct spec SEGMENTS across
// all master products (the BE unnests the '; '-joined column), most-used
// first. Feeds the SpecTagsInput autocomplete; `q` narrows via ILIKE.
const endpoint = `${masterProductsEndpoint}/spec-values`;

export const useGetSpecValueSuggestionsApi = (q: string, options: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: [endpoint, q],
    queryFn: async (): Promise<string[]> => {
      const { data } = await http.get(endpoint, { params: { q: q || undefined, limit: 8 } });
      return data?.data ?? [];
    },
    enabled: (options.enabled ?? true) && !!q,
    keepPreviousData: true,
    staleTime: 1000 * 60,
    cacheTime: 1000 * 60 * 5,
  });
};
